class Countdown {

    constructor() {
      this.countdown = document.querySelector('.js-countdown')
    }
  
    init() {
      this.events()
    }
  
    events() {
		let self = this;

		if ( self.countdown ) {
			
			self.updateCount()
			.then( ( response ) => {
				self.renderCount( response )
			})

			setInterval( () => {
				self.updateCount()
				.then( ( response ) => {
					self.renderCount( response )
				})
			}, 1000);
		}
  
    }
  
    async updateCount () {

		const form = new FormData();
		form.append('action', 'update_count');
		form.append('nonce', main_js.nonce);

		const response = await fetch(main_js.ajaxurl, {
			method: 'POST',
			body: form,
			credentials: 'same-origin',
		});

		if ( response.ok ) {
			const markup = await response.text()
			return markup;
		}

		console.error('Get count error:', response.status);

    }

	renderCount( response ) {
		if ( response == '_refresh' ) {
			location.reload();
		} else {
			this.countdown.innerHTML = response;
		}
	}

  }
  
  export default Countdown
  